import { GET_ALL_BRANCHES, GET_BRANCH, RESET_BRANCH, GET_BRANCHES_FOR_SELECT } from './types'

const initialState = {
  branches: [],
  branch: {},
  loading: false,
  optionsForSelect: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_BRANCHES_FOR_SELECT:
      return {
        ...state,
        optionsForSelect: action.payload,
      }
    case GET_BRANCH:
      return {
        ...state,
        branch: action.payload,
      }
    case GET_ALL_BRANCHES:
      return {
        ...state,
        branches: action.payload,
      }
    case RESET_BRANCH:
      return {
        ...state,
        branch: action.payload,
      }
    default:
      return state
  }
}
